import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { DeadEmbryoBaseService } from './deadembryo-base.service';

@Injectable()
export class DeadEmbryoService extends DeadEmbryoBaseService {
  constructor() {
    const http = inject(HttpClient);

    super(http);
  }
}
